import {
  isEditPublisher,
  isEventPublisher,
  isGroupPublisher,
  isTeamsMeetingReplyPublisher,
  isTeamsMeetingThreadStarterPublisher,
} from '../../state/publishers/types';
import type { Group, Publisher, YammerState } from '../../state/types';
import { findByIdThrows as findMessageThrows } from '../messages/selectors';
import { findTeamsMeetingById } from '../teamsMeetings/selectors';
import { findByIdThrows as findThread, findById as findThreadById } from '../threads/selectors';

import { findByIdThrows as getPublisherThrows } from './findPublisherSelectors';

type GetGroupId = (state: YammerState, publisherId: Publisher['id']) => Group['id'] | undefined | null;
export const getGroupId: GetGroupId = (state, publisherId) => {
  const publisher = getPublisherThrows(state, publisherId);

  if (isGroupPublisher(publisher) || isEventPublisher(publisher)) {
    return publisher.groupId;
  }

  if (isTeamsMeetingThreadStarterPublisher(publisher)) {
    const teamsMeeting = findTeamsMeetingById(state, publisher.teamsMeetingId);

    return teamsMeeting?.group?.id;
  }

  if (isTeamsMeetingReplyPublisher(publisher)) {
    return findThreadById(state, publisher.threadId)?.groupId;
  }

  if (isEditPublisher(publisher)) {
    const { threadId } = findMessageThrows(state, publisher.messageId);
    const { groupId } = findThread(state, threadId);

    return groupId;
  }

  return;
};
